import styled from "styled-components";

export const Container = styled.div`
    .SignInLink
    {
        font-family: 'inter';
        font-size: 14px;
        color: var(--primary-color);
        text-align: center;

        a {
            cursor: pointer;
            text-decoration: underline;        
        }
    }
    .PrivacyPolicy {
        text-decoration: none;
        color: royalblue;
    }

    .PrivacyPolicyLink
    {
        padding-top: 1.5vh;

        font-family: Inter;
        font-size: 10px;
        font-weight: 400;
        line-height: 17px;
        text-align: center;
        color: #020219;
    }
`;